/* global GMaps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Loader from '@/components/Loader';

LocationMap.propTypes = {
  location: PropTypes.object.isRequired,
  cursor: PropTypes.string
};

export default function LocationMap(props) {
  const { location, cursor = 'pointer' } = props;

  useEffect(() => {
    let cancelled = false;

    function onGeocodedAddress(results, status) {
      if (status !== 'OK') {
        if (cancelled) return;

        try {
          new GMaps({
            div: `#map-${location.id}`,
            lat: 37.923483,
            lng: -99.650695,
            zoom: 3,
            // hide controls
            // zoomControl: false,
            // mapTypeControl: false,
            // scaleControl: false,
            // streetViewControl: false,
            // rotateControl: false,
            // fullscreenControl: false,
            // disable default UI and set cursor to pointer
            draggable : false,
            disableDefaultUI : true,
            clickableIcons: false,
            keyboardShortcuts: false,
            gestureHandling: 'none',
            draggableCursor: cursor
          });
        } catch (_e) {
          // ignore
        }

        return;
      }

      const latlng = results[0].geometry.location;

      if (cancelled) return;

      try {
        const map = new GMaps({
          div: `#map-${location.id}`,
          lat: latlng.lat(),
          lng: latlng.lng(),
          zoom: 13,
          // hide controls
          // zoomControl: false,
          // mapTypeControl: false,
          // scaleControl: false,
          // streetViewControl: false,
          // rotateControl: false,
          // fullscreenControl: false,
          // disable default UI and set cursor to pointer
          draggable : false,
          disableDefaultUI : true,
          clickableIcons: false,
          keyboardShortcuts: false,
          gestureHandling: 'none',
          draggableCursor: cursor
        });

        const hide = {
          stylers: [{visibility: 'off'}]
        };

        /*
         * Docs for changing map styles can be found here:
         * https://developers.google.com/maps/documentation/javascript/style-reference
         */

        map.setOptions({
          styles: [
            // { featureType: 'all', ...hide },
            { featureType: 'administrative', ...hide },
            // { featureType: 'landscape', ...hide },
            { featureType: 'poi', ...hide },
            // { featureType: 'road', ...hide },
            { featureType: 'transit', ...hide },
            // { featureType: 'water', ...hide },
          ]
        });

        // // map.setCenter(latlng.lat(), latlng.lng());
        map.addMarker({
          lat: latlng.lat(),
          lng: latlng.lng()
        });
      } catch (_e) {
        // ignore
      }
    }

    GMaps.geocode({
      address: `${location.data.addressLine1},${location.data.city},${location.data.state},${location.data.zipCode}`,
      callback: onGeocodedAddress.bind(this)
    });

    return () => {
      cancelled = true;
    };
  }, [location, cursor]);

  return (
    <div id={`map-${location.id}`} className="cs-map h-full">
      <Loader />
    </div>
  );
};
